import React, { useState } from 'react';
import { Film } from 'lucide-react';
import { isVideoMediaItem, mediaItemUrl } from './socialMediaUtils';
import {
  isSocialThumbCached,
  isSocialThumbFailed,
  markSocialThumbFailed,
  markSocialThumbLoaded,
} from './socialThumbCache';

const DEFAULT_CLASS =
  'h-12 w-12 shrink-0 rounded overflow-hidden border border-gray-200 dark:border-white/15 bg-black';

export default function GymSocialMediaThumb({ item, className = DEFAULT_CLASS }) {
  const url = mediaItemUrl(item);
  const cached = url ? isSocialThumbCached(url) : false;
  const failed = url ? isSocialThumbFailed(url) : false;
  const [ready, setReady] = useState(cached);
  const [imgFailed, setImgFailed] = useState(failed);

  if (!url) {
    return null;
  }

  if (isVideoMediaItem(item)) {
    return (
      <div className={`relative ${className}`}>
        <video
          src={url}
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover"
          onLoadedData={() => markSocialThumbLoaded(url)}
          aria-hidden
        />
        <span
          className="absolute bottom-0.5 right-0.5 rounded bg-black/65 p-0.5 text-white pointer-events-none"
          aria-hidden
        >
          <Film className="h-3 w-3" />
        </span>
      </div>
    );
  }

  if (imgFailed) {
    return (
      <span
        className={`inline-flex items-center justify-center bg-gray-300 text-gray-600 text-[9px] dark:bg-gray-700 dark:text-gray-300 ${className}`}
        aria-hidden
      >
        ?
      </span>
    );
  }

  return (
    <img
      src={url}
      alt=""
      loading="lazy"
      className={`object-cover transition-opacity duration-150 ${ready ? 'opacity-100' : 'opacity-0'} ${className}`}
      onLoad={() => {
        markSocialThumbLoaded(url);
        setReady(true);
      }}
      onError={() => {
        markSocialThumbFailed(url);
        setImgFailed(true);
      }}
    />
  );
}
